import { useReducer } from 'react';
import { theme } from '@frameio/vapor-theme';

export type StateActions =
  | 'addMemberRow'
  | 'animationCompleted'
  | 'queriedWithoutSearchTerm'
  | 'removeMemberRow'
  | 'searchedAndDidNotReceiveResults'
  | 'searchedAndReceivedResults';

export const INITIAL_ROW_STYLE = {
  backgroundColor: theme.colors.background.interactive.highlight,
  height: '0px',
  opacity: 0,
};

export const initialState = {
  hasResults: true,
  hasActiveSearchTerm: false,
  isAnimatingImperatively: false,
};

function reducer(state: typeof initialState, action: StateActions) {
  switch (action) {
    case 'addMemberRow':
      return {
        ...state,
        isAnimatingImperatively: true,
      };
    case 'animationCompleted':
      return {
        ...state,
        isAnimatingImperatively: false,
      };
    case 'queriedWithoutSearchTerm':
      return {
        ...state,
        hasResults: true,
        hasActiveSearchTerm: false,
      };
    case 'removeMemberRow':
      return {
        ...state,
        isAnimatingImperatively: true,
      };
    case 'searchedAndDidNotReceiveResults':
      return {
        ...state,
        hasResults: false,
        hasActiveSearchTerm: true,
      };
    case 'searchedAndReceivedResults':
      return {
        ...state,
        hasResults: true,
        hasActiveSearchTerm: true,
      };

    default:
      return state;
  }
}

export const useListAnimationState = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    animationState: state,
    animationStateDispatch: dispatch,
  };
};
